document.addEventListener('DOMContentLoaded', () => {
  const searchForms = document.querySelectorAll('.search-modal__form');

  if (!searchForms.length) return;

  searchForms.forEach((form) => {
    const searchInput = form.querySelector('.search__input');

    if (!searchInput) return;

    const resetBtn = form.querySelector('.reset__button');
    const modalContent = form.closest('.search-modal__content');
    let terms = [];

    if (modalContent) {
      terms = modalContent.querySelectorAll('[data-search-term]');
    }

    if (terms.length) {
      const handleTermClick = (e) => {
        searchInput.value = e.target.innerText;
  
        setTimeout(() => {
          form.submit();
        }, 500);
      }

      terms.forEach((term) => { term.addEventListener('click', handleTermClick); });
    }

    if (resetBtn) {
      const handleResetClick = (e) => {
        e.preventDefault();
        searchInput.value = '';
      }
    
      resetBtn.addEventListener('click', handleResetClick);
    }
  });
});